"use client"

import React, { useState } from "react"
import ContactDialog from "./contact-dialog"

interface ProfileContactSectionProps {
  profileId: string
  profileName: string
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary'
}

export default function ProfileContactSection({
  profileId,
  profileName,
  children,
  className = "",
  variant = 'primary'
}: ProfileContactSectionProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleClick = () => {
    setDialogOpen(true)
  }

  const buttonClasses = variant === 'primary'
    ? "w-full bg-[#6b93ce] hover:bg-[#5a82bd] text-white rounded-full py-3 px-6 text-sm font-semibold uppercase tracking-wider transition-all transform hover:scale-[1.02]"
    : "bg-[#6b9bd2] hover:bg-[#5a8bc2] text-white font-semibold py-3 px-6 rounded-full transition-colors uppercase inline-flex items-center"

  return (
    <>
      <button
        onClick={handleClick}
        className={className || buttonClasses}
      >
        {children}
      </button>
      <ContactDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        profileName={profileName}
        profileId={profileId}
      />
    </>
  )
}